// src/locales/en/errors.js
export const errors = {
    somethingWentWrong: "Something went wrong. Please try again.",
    networkError: "Network error. Please check your connection.",
    permissionDenied: "Permission denied. You don't have access to this resource.",
    pageNotFound: "Page not found",
    notFound: "Not found",
    sessionExpired: "Your session has expired. Please login again.",
    invalidData: "Invalid data provided",
    serverError: "Server error. Please try again later.",
    loadingError: "Loading Error",
}